// TODO: BUG: fix dependency cycle with facet
import type { IMediaType } from '~/entities/content/media/interfaces/media-type'

import type { IFacetSetting } from '~/features-shared/facet/interfaces/facet'

export enum ExperienceName {
  PROJECT = 'project',
  DATA_PERSPECTIVE = 'data_perspective',
  MEDIA_SPOTLIGHT = 'media_spotlight',
  ISSUE_MANAGEMENT = 'issue_management',
  BOOKMARK_EDITOR = 'bookmark_editor',
  DOCUMENT_MANAGEMENT = 'document_management',
  CONSTRUCTION_PLANNING_BOARD = 'construction_planning_board',
  THREEDLEAN = '3dlean',
}

/**
 * Experiences that support customizable icon and color
 */
export const CUSTOMIZABLE_ICON_COLOR_EXPERIENCES: ExperienceName[] = [ExperienceName.MEDIA_SPOTLIGHT]

export interface IExperience {
  name: ExperienceName
  label: string
  icon: string
  color: string
  order: number

  serviceName: string
  appId: string

  resourceId?: string
  resourceName?: string
}

export interface IExperienceSetting extends IFacetSetting,
  Omit<IExperience, 'name' | 'order'> {
  experienceName: ExperienceName
  isEditable: boolean
}

export interface ExperienceData {
  type: ExperienceName
  label: string
  color: string
  icon: string
  resourceId?: string
  resourceName?: string
  widgetPreference: string
}

/**
 * For Modal Experience Configure only
 */
export interface ExperienceResourceData {
  /**
   * The label of the resource
   */
  label: string
  /**
   * The value of the resource (UUID, URI, etc.)
   * Only for VuMultipleSelect
   */
  value: string
  /**
   * The source URL of the thumbnail
   * To be displayed before the resource title
   * For Project Planning & Data Perspective only
   */
  src?: string
  /**
   * The type of media
   * Used to display the corresponding media icon before the resource title
   * For Media Spotlight only
   */
  type?: IMediaType
}
